
import { defineComponent, PropType } from 'vue'
import { useField } from 'vee-validate'

export type FormatFunction = (value: string) => string

export type Rule = Parameters<typeof useField>[1]

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    format: {
      type: Function as PropType<FormatFunction>,
      required: false
    },
    validator: {
      type: [Object, String, Function] as PropType<Rule>,
      required: false
    },
    initValue: {
      type: String,
      required: false,
      default: ''
    }
  },
  emits: ['input'],
  setup (props, { emit }) {
    const { value, errors, validate } = useField<string>(
      props.name,
      props.validator,
      {
        initialValue: props.initValue,
        validateOnValueUpdate: false
      }
    )

    const handleInput = ({ target }: { target: HTMLInputElement }) => {
      emit('input', target.value)
    }

    const formatUpdate = async ({ target }: { target: HTMLInputElement }) => {
      value.value = props.format ? props.format(target.value) : target.value
      emit('input', value.value)

      await validate()
    }

    return { value, errors, handleInput, formatUpdate }
  }
})
